import { render, staticRenderFns } from "./editProductShopee.vue?vue&type=template&id=41f87852&scoped=true"
import script from "./editProductShopee.vue?vue&type=script&lang=js"
export * from "./editProductShopee.vue?vue&type=script&lang=js"
import style0 from "./editProductShopee.vue?vue&type=style&index=0&id=41f87852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f87852",
  null
  
)

export default component.exports